// @flow
import React from 'react';
import type { Element } from 'react';

import { uniqBy } from 'lodash';

import { IMAGE_FALLBACK_COMPANY, IMAGE_FALLBACK_FACILITY } from '@lib/constants';


import { MapMarker } from '@components';
import { DETAILS_DOCTOR } from '@routes';
import type { Doctor, Photo } from './types';

export const objectToMarkers = (objectList: Array<Doctor>, t: (key: string) => string) => (): Array<
  Element<any>
> => {
  const getCoordinatesFromJob = (job: Doctor): string =>
    (job?.relationships?.facility?.data?.attributes?.latitude || '')
    + (job?.relationships?.facility?.data?.attributes?.longitude || '');

  const jobToMarker = ({
    id,
    attributes: { name, department, slug },
    relationships: { facility, facility_group }
  }: Doctor): Element<any> => {
    const photos: Array<Photo> = facility_group?.data?.relationships?.photos?.data || [];

    const companyPhotoUrls: Array<string> = photos.map(
      (photo: Photo): string => photo.attributes.photo_url
    );

    const placePhotoUrls: Array<string> = (facility?.data?.relationships?.photos?.data || []).map(
      (photo: Photo): string => photo.attributes.photo_url
    );

    const photoUrls: Array<string> = [
      ...companyPhotoUrls,
      ...placePhotoUrls,
      IMAGE_FALLBACK_COMPANY,
      IMAGE_FALLBACK_FACILITY
    ];

    const position: string = t(`positions.${name}`);
    const department_name: string = department && t(`departments.${department}`);

    return (
      <MapMarker
        lat={parseFloat(facility?.data?.attributes?.latitude)}
        lng={parseFloat(facility?.data?.attributes?.longitude)}
        popoverContent={{
          srcImage1: photoUrls[0],
          srcImage2: photoUrls[1],
          title: position,
          subtitle: department_name,
          route: {
            name: DETAILS_DOCTOR,
            params: { slug },
            label: t('BookConsultation')
          }
        }}
        key={id}
      />
    );
  };

  return uniqBy(objectList, getCoordinatesFromJob).map(jobToMarker);
};
